import React from 'react';
import AccountPage from 'commons/src/features/settingsPage/AccountPage';
import { RequiredRoleLevel } from 'commons/src/models/commonEnums';
import { TabOption } from 'commons/src/models/menuModels';
import { paths } from '../../constants';

const ConsumerAccountsPage = (): React.ReactElement => {
    const consumerTabs: TabOption[] = [
        {
            text: 'Overview',
            path: `/${paths.settings}`,
            id: 'consumerSettingsOverview',
            testAttr: 'consumer-settings-overview',
            requiredRoleLevel: RequiredRoleLevel.ANY_ROLE,
            route: paths.settings,
            requiredGroupTypes: [],
        },
        {
            text: 'Security',
            path: `/${paths.security}`,
            id: 'securitySettings',
            testAttr: 'security-settings',
            requiredRoleLevel: RequiredRoleLevel.ANY_ROLE,
            route: paths.security,
            requiredGroupTypes: [],
        },
    ];

    return <AccountPage tabs={consumerTabs} />;
};

export default ConsumerAccountsPage;
